import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import {FormService} from '../shared/dhl-form/services/form.service'

@Injectable({
  providedIn: 'root'
})
export class CoxService {

  constructor(private appService: AppService, public formService: FormService) { }

  public orderId;
  
  setOrderId(val: string){
    this.orderId = val;
  }
  getOrderId():string{
    return this.orderId;
  }
  

  public increaseHoldReleaseDateBy1Hour(payload, attribute) {
    let holdReleaseDate = new Date(new Date(payload[attribute]) + "UTC");
    let releaseDate = new Date(new Date(payload[attribute]) + "UTC").setHours(0, 0, 0, 0);
    let today = new Date().setHours(0, 0, 0, 0);
    if (releaseDate == today) {
      holdReleaseDate = new Date(holdReleaseDate.setHours(holdReleaseDate.getHours() + 1));
      payload[attribute] = new Date(this.appService.formatDateForExport(holdReleaseDate)).toISOString().slice(0, -1);
    }
    return payload;
  }
  public increaseHoldReleaseDateBy10Years(){
    let newDate;
      let holdReleaseDate = new Date();
      holdReleaseDate = new Date(holdReleaseDate.setFullYear(holdReleaseDate.getFullYear() + 10));
      newDate = new Date(this.appService.formatDateForExport(holdReleaseDate)).toISOString().slice(0, -1);
      let val = {displayValue: this.appService.getSystemDateMMddyyyy(new Date(newDate)),
                value: newDate}
      return val;
  }

  public increaseHoldReleaseDateBy21Days(){
    let newDate;
      let holdReleaseDate = new Date();
      holdReleaseDate = new Date(holdReleaseDate.setDate(holdReleaseDate.getDate() + 21));
      newDate = new Date(this.appService.formatDateForExport(holdReleaseDate)).toISOString().slice(0, -1);
      let val = {displayValue: this.appService.getSystemDateMMddyyyy(new Date(newDate)),
        value: newDate}
      return val;
  }
 
  //Cp-4228 - start
  public getAccessorialCodeForFeeApproved(template): any {
    let result = "";
    if(template["sections"]) {
      template["sections"].forEach(section => {
        result = this.getAccessorialCodeKey(section, result)
      });
    } 
    else {
      result = this.getAccessorialCodeKey(template, result)
    }
    return result;
  }

  public getAccessorialCodeKey(template, result): any {
    template["groups"].forEach(group => {
      group["controls"].forEach(control => {
        if (control['name'] == "vehicleDetails_accessorialFeesUI") {
          control['controls'].forEach(element => {
            if (element['name'] === 'accessorialCode') {
              element['affectedColumns'].forEach(item => {
                let multipleValue;
                let multipleKey;
                if(item['multipleValue'] && item['multipleKey']){
                  multipleValue = item['multipleValue'];
                  multipleKey = item['multipleKey'];
                } else {
                  multipleValue = item['value'];
                  multipleKey = item['key'];
                }
                if (multipleValue[0]['name'] === 'feeApproved') {
                  result = multipleKey;
                }
              })
            }
          });
        }
      });
    });
    return result;
  }
  //Cp-4228 - end
 
  // START: CP-5611 
  public calculateRemainingSla(slaDueDate) {
    let remainingSla = '';
    let fututreFlag = true;
    if (+new Date(new Date(slaDueDate) + "UTC") > +new Date()) {
      fututreFlag = true;
    } else {
      fututreFlag = false;
    }
    remainingSla = this.appService.getDifferenceBetweenDates(new Date(new Date(slaDueDate) + "UTC"), new Date(), fututreFlag);
    return remainingSla;
  }
  // END: CP-5611 

  public separatePascalCase(val){
    if(val){
      let status = val;
      let updatedStatus = "";
        if (val.toString().startsWith('3P')){
          updatedStatus = val.toString().substring(0,2);
          status = val.toString().substring(2);
        }
        status=status.replace(/([A-Z]+)([A-Z][a-z])/g, ' $1 $2')
        .replace(/([a-z\d])([A-Z])/g, '$1 $2')
        .replace(/([a-zA-Z])(\d)/g, '$1 $2')
        .replace(/^./, function(str){ return str.toUpperCase(); })
        .trim();
        if(updatedStatus){
            status = updatedStatus+" "+status;
        }
        val=status;
      }

    return val;
  }
}
